export default __webpack_public_path__ + "static/media/model937.e47b0b0b.svg";